import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

/**
 * Every tool page is lazy-loaded, so the heavy libraries each one needs (docx, pptxgenjs, qpdf, ...)
 * only download when somebody opens that tool.
 */
export const ROUTES: Record<string, LazyExoticComponent<ComponentType>> = {
  '/edit': lazy(() => import('./App')),
  '/compress': lazy(() => import('./tools/compress/CompressPage')),
  '/compare-pdf': lazy(() => import('./tools/compare/ComparePage')),
  '/jpg-to-pdf': lazy(() => import('./tools/jpg-to-pdf/JpgToPdfPage')),
  '/pdf-to-jpg': lazy(() => import('./tools/pdf-to-jpg/PdfToJpgPage')),
  '/protect-pdf': lazy(() => import('./tools/protect/ProtectPage')),
  '/sign-pdf': lazy(() => import('./tools/sign/SignPage')),
  '/pdf-forms': lazy(() => import('./tools/forms/FormsPage')),
  '/pdf-to-word': lazy(() => import('./tools/word/PdfToWordPage')),
  '/pdf-to-powerpoint': lazy(() => import('./tools/powerpoint/PdfToPowerPointPage')),
  '/word-to-pdf': lazy(() => import('./tools/word-to-pdf/WordToPdfPage')),
};
